import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container text-center" }
const _hoisted_2 = { class: "cuscd-footer-wrap" }
const _hoisted_3 = { class: "row mb-3" }
const _hoisted_4 = { class: "cuscd-footer-col" }
const _hoisted_5 = ["target"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "cuscd-footer-col" }
const _hoisted_9 = { class: "cuscd-desc" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "cuscd-footer-col" }
const _hoisted_12 = { class: "cuscd-desc-sm" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "cuscd-desc-sm" }

import { ImageConstants } from "@/config/constants";
import { computed } from "vue";
import { useStore } from "vuex";
import ZohoSalesIQ from "@/components/widgets/ZohoSalesIQ.vue";
import { LenderBranding } from "@/store/applicationsModule";

interface Props {
  externalLinks: boolean;
  lid: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StudentChoiceFooter',
  props: {
    externalLinks: { type: Boolean, default: false },
    lid: { default: 0 }
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const identityUrl = computed(() => store.state.configuration?.identityUrl);
const termsOfUseUrl = computed<string>(() => "https://identity.studentchoice.org/Home/Terms");
const cdnImagesUrl = computed(() => store.getters["cdnImagesUrl"]);
const cuLogoUrl = computed(() => store.getters["cuLogoUrl"]);
const footerLogoUrl = computed<string>(
  () => `${cdnImagesUrl?.value}/${ImageConstants.FOOTER_LOGO}`,
);

const zohoSalesIQChatEnabled = computed<boolean>(() => {
  // if no branding
  if (!branding.value) {
    return false;
  }

  if (branding.value && branding.value.lenderId > 0) {
    return branding.value.zohoSalesIQChatEnabled;
  }

  return store.state.configuration?.zohoSalesIQChatEnabled;
});

const branding = computed<LenderBranding | undefined>(
  () => store.getters["applicationsModule/Branding"],
);

const year = computed<number>(() => new Date().getFullYear());

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            href: "https://studentchoice.org",
            target: __props.externalLinks ? '_blank' : undefined
          }, [
            _createElementVNode("img", {
              src: footerLogoUrl.value,
              alt: "Student Choice",
              class: "cuscd-footer-img"
            }, null, 8, _hoisted_6)
          ], 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, [
            _createVNode(_component_router_link, {
              to: { path: '/support', query: { lid: __props.lid } },
              target: "_blank"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" Support ", -1)
              ]))]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, [
            _cache[2] || (_cache[2] = _createTextVNode(" By using this site, you accept our ", -1)),
            _createElementVNode("a", {
              href: termsOfUseUrl.value,
              target: "_blank"
            }, "Terms of Use", 8, _hoisted_13),
            _cache[3] || (_cache[3] = _createTextVNode(" and ", -1)),
            _createVNode(_component_router_link, {
              to: "/privacyPolicy",
              target: "_blank"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" Privacy Policy ", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("p", _hoisted_14, "Student Choice © " + _toDisplayString(year.value) + " All Rights Reserved", 1),
          _cache[4] || (_cache[4] = _createElementVNode("a", {
            class: "cuscd-desc-sm",
            target: "_blank",
            href: "https://nmlsconsumeraccess.org/"
          }, " NMLS #2123582 – NMLS Consumer Access ", -1))
        ]),
        _createVNode(ZohoSalesIQ, {
          zohoSalesIQChatEnabled: zohoSalesIQChatEnabled.value,
          branding: branding.value
        }, null, 8, ["zohoSalesIQChatEnabled", "branding"])
      ])
    ])
  ]))
}
}

})